import userManageRouter from './userManageRouter'
import dataAnalysisRouter from './dataAnalysisRouter'
import hospitalManageRouter from './hospitalManageRouter'
import systemConfigRouter from './systemConfigRouter'

const route = {
  path: '/contour',
  name: '公共页',
  component: () => import('../views/home/home'),
  children: [
    userManageRouter,
    dataAnalysisRouter,
    hospitalManageRouter,
    systemConfigRouter
  ],
  meta: {
    title: '优安智管血糖管理系统'
  }
}

export default route



// WEBPACK FOOTER //
// ./src/router/homeRouter.js